import React, { useState } from "react";
import { ChevronDownIcon } from "../../../../helper/HwIconExcursion";
import { ChevronUpIcon } from "../../../../helper/HwIcon";
import HwSelect from "../../../../component/HwSelect";
import HwPlainSelect from "../../../../component/HwPlainSelect";
import { countryWithDialCode } from "../../../../helper/CountryWithDialCode";

const suffixUpdateKey = ["lastName"];

export const PersonDetailsCard = ({
  title,
  values,
  index,
  item,
  setFieldValue,
  errors,
  touched,
  mainForm,
  allValues,
  isEmaar,
  isEmaarV1,
  isBurjKhalifa,
  isHelidubai,
  isDubaiPark,
  showWeightForHeliDubai,
}) => {
  const [open, setOpen] = useState(true);
  const [keyword, setKeyword] = useState();
  const countryWithDialCodeArr = countryWithDialCode();
  const countryData = countryWithDialCodeArr?.map((item) => {
    let countryCode = item.country_code?.toLowerCase();
    if (countryCode === 'uae') {
      countryCode = 'ae';
    } else if (countryCode === 'uk') {
      countryCode = 'gb';
    }
    return {
      value: countryCode,
      label: item.country_name,
    };
  }) ?? [];


  const getUpdatedValues = (
    d,
    i,
    key,
    value,
    total
  ) => {
    let val = (key === "phoneNumber" || key === 'nationality') ? value : d?.[key] || value;
    if (
      suffixUpdateKey.includes(key) &&
      val &&
      !isEmaar &&
      !isEmaarV1 &&
      !isBurjKhalifa
    ) {
      const base = String(val).replace(/\s*X\s*\d+\s*\/\s*\d+\s*$/i, "").trim();
      val = `${base} X ${i + 1} / ${total}`;
    }
    return {
      ...d,
      [key]: val,
    };
  };
  const onBlurPrefill = (key, value) => {
    try {
      if (!mainForm) {
        return;
      }
      const adults = allValues?.adults?.length ?? 0;
      const child = allValues?.child?.length ?? 0;
      const infants = allValues?.infants?.length ?? 0;
      const total = adults + child + infants;

      setFieldValue(
        "adults",
        allValues?.adults?.map((d, i) => {
          return getUpdatedValues(
            d,
            i,
            key,
            value,
            total
          );
        })
      );
      setFieldValue(
        "child",
        allValues?.child?.map((d, i) => {
          return getUpdatedValues(
            d,
            adults + i,
            key,
            value,
            total
          );
        })
      );
      setFieldValue(
        "infants",
        allValues?.infants?.map((d, i) => {
          return getUpdatedValues(
            d,
            adults + child + i,
            key,
            value,
            total
          );
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="hw-passenger--detailsGroupItem fare-toggle-parent active">
      <div
        onClick={() => {
          setOpen(!open);
        }}
        className="d-flex align-items-center justify-between hw-passenger--fareShowToggle"
      >
        <span className="d-flex align-items-center hw-gapy10 hw-blue hw-text14 hw-fontBold">
          {title}
        </span>
        {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </div>
      <div
        className="hw-passenger--fareShowToggleContent"
        style={open ? {} : { display: "none" }}
      >
        <div className="row">
          <div className="col-sm-4 col-xl-3">
            <HwPlainSelect
              value={values?.gender || ""}
              placeholder="Prefix*"
              options={[
                { value: "Male", label: "Male" },
                { value: "Female", label: "Female" },
              ]}
              onChange={(val) => {
                setFieldValue(`${item?.type}[${index}][gender]`, val);
                onBlurPrefill("gender", val);
              }}
              error={errors?.gender && touched?.gender}
            />
            {errors?.gender && touched?.gender ? (
              <p className="hw-p-error-cls mb-0">{errors?.gender}</p>
            ) : null}
          </div>
          <div className="col-sm-4 col-xl-4">
            <input
              placeholder="First Name*"
              id="fname"
              className="hw-form--input"
              onChange={(e) => {
                setFieldValue(
                  `${item?.type}[${index}][firstName]`,
                  e.target.value
                );
              }}
              value={values?.firstName}
              onBlur={(e) => {
                onBlurPrefill("firstName", e.target.value);
              }}
            />
            {errors?.firstName && touched?.firstName ? (
              <p className="hw-p-error-cls mb-0">{errors?.firstName}</p>
            ) : null}
          </div>
          <div className="col-sm-4 col-xl-5">
            <input
              placeholder="Last Name*"
              id="lname"
              className="hw-form--input"
              onChange={(e) => {
                setFieldValue(
                  `${item?.type}[${index}][lastName]`,
                  e.target.value
                );
              }}
              value={values?.lastName}
              onBlur={(e) => {
                onBlurPrefill("lastName", e.target.value);
              }}
            />
            {errors?.lastName && touched?.lastName ? (
              <p className="hw-p-error-cls mb-0">{errors?.lastName}</p>
            ) : null}
          </div>
          {
            isDubaiPark ? (
                <div className="col-md-6">
                  <HwSelect
                      placeholder="Nationality*"
                      options={countryData}
                      onChangeFn={(selected) => {
                        setFieldValue(`${item?.type}[${index}][nationality]`, selected);
                        onBlurPrefill('nationality', selected);
                        setKeyword("");
                      }}
                      value={values?.nationality}
                      menuChnageFn={() => null}
                      onInputChangeFn={(value) => {
                        setKeyword(value)
                      }}
                      loading={false}
                      isMulti={false}
                      type={"country"}
                      isError={errors?.nationality && touched?.nationality}
                      inputValue={keyword}
                  />
                  {errors?.nationality && touched?.nationality ? (
                      <p className="hw-p-error-cls mb-0">{errors?.nationality}</p>
                  ) : null}
                </div>
            ) : null
          }
          {isHelidubai ? (
            <>
              <div className="col-md-6">
                <input
                  placeholder="Phone Number*"
                  id="phone-number"
                  className="hw-form--input"
                  onChange={(e) => {
                    setFieldValue(
                      `${item?.type}[${index}][phoneNumber]`,
                      e.target.value
                    );
                  }}
                  value={values?.phoneNumber}
                  onBlur={(e) => {
                    onBlurPrefill("phoneNumber", e.target.value);
                  }}
                />
                {errors?.phoneNumber && touched?.phoneNumber ? (
                  <p className="hw-p-error-cls mb-0">{errors?.phoneNumber}</p>
                ) : null}
              </div>
              {showWeightForHeliDubai ? (
                <div className="col-md-6">
                  <input
                    placeholder="Weight*"
                    id="weight"
                    className="hw-form--input"
                    onChange={(e) => {
                      setFieldValue(
                        `${item?.type}[${index}][weight]`,
                        e.target.value
                      );
                    }}
                    value={values?.weight}
                    // onBlur={(e) => {
                    //   onBlurPrefill("weight", e.target.value);
                    // }}
                  />
                  {errors?.weight && touched?.weight ? (
                    <p className="hw-p-error-cls mb-0">{errors?.weight}</p>
                  ) : null}
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};
